define([
	'internal_util/Logger',
	'internal_util/Util',
	'internal_util/XMLUtil',
	'model/ProviderInfo',
	'model/Image'
], function (
	Logger,
	Util,
	XMLUtil,
	ProviderInfo,
	Image
) {
	'use strict';

	/**
	 * ProviderInfoFactory class
	 */
	return new function () {
		var metadataNamespace = 'urn:oasis:names:tc:SAML:2.0:metadata',
			metadataUiNamespace = 'urn:oasis:names:tc:SAML:metadata:ui';


		// public methods

		this.create = function (optionsXML) {
			var uiInfo = XMLUtil.find(metadataUiNamespace, optionsXML, 'UIInfo'),
				organization = XMLUtil.find(metadataNamespace, optionsXML, 'Organization'),
				logo = XMLUtil.find(metadataUiNamespace, uiInfo, 'Logo', true),
				poweredByLogo = XMLUtil.find(metadataUiNamespace, uiInfo, 'PoweredByLogo', true),
				name,
				url,
				description,
				image,
				poweredByImage,
				privacyStatement;

			name = XMLUtil.find(metadataNamespace, organization, 'OrganizationDisplayName').text().trim();
			url = XMLUtil.find(metadataUiNamespace, uiInfo, 'InformationURL', true).text().trim();
			description = XMLUtil.find(metadataUiNamespace, uiInfo, 'DisplayName', true).text().trim();
			image = new Image(logo.text().trim(), logo.attr('width'), logo.attr('height'));
			privacyStatement = XMLUtil.find(metadataUiNamespace, uiInfo, 'PrivacyStatementURL', true).text().trim();
			
			if (poweredByLogo.length > 0) {
				poweredByImage = new Image(poweredByLogo.text().trim(), poweredByLogo.attr('width'), poweredByLogo.attr('height'));
			}

			return new ProviderInfo(name, url, description, image, privacyStatement, poweredByImage);
		};

		this.createFromObject = function (providerInfoObject) {
			return new ProviderInfo(
					providerInfoObject['name'],
					providerInfoObject['url'],
					providerInfoObject['description'],
					new Image(providerInfoObject['image']['url'],
							providerInfoObject['image']['width'],
							providerInfoObject['image']['height']),
					providerInfoObject['privacyStatement'],
					new Image(providerInfoObject['poweredByImage']['url'],
							providerInfoObject['poweredByImage']['width'],
							providerInfoObject['poweredByImage']['height']));
		};
	};
});


//////////////////
// WEBPACK FOOTER
// ./src/main/web/js/app/factory/ProviderInfoFactory.js
// module id = 273
// module chunks = 7